export const FHIR_USER_ID_SYSTEM = 'https://fhir.mieros.cloud/fhir/ids';

export const ensureFhirUserIdentifier = (resource, uid) => {
  if (!resource || typeof resource !== 'object' || !uid) return resource;

  const identifiers = Array.isArray(resource.identifier) ? [...resource.identifier] : [];
  const hasUserId = identifiers.some(
    (id) => id?.system === FHIR_USER_ID_SYSTEM && String(id?.value || '') === String(uid)
  );

  if (!hasUserId) {
    identifiers.push({
      system: FHIR_USER_ID_SYSTEM,
      value: uid,
    });
  }

  return {
    ...resource,
    identifier: identifiers,
  };
};
